import React from 'react';
import { Skeleton, Typography, Space } from 'antd';

const { Text } = Typography;

const AuctionCardSkeleton = ({ viewMode = 'grid' }) => {
    return (
        <>
            <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                height: viewMode === 'list' ? 'auto' : '100%',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                border: '1px solid #e5e7eb',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                background: '#ffffff',
                position: 'relative'
            }} className="skeleton-card">
                {/* Cover Image Section */}
                <div style={{ 
                    position: 'relative',
                    height: viewMode === 'list' ? 280 : 200,
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: '16px'
                }}>
                    <div style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        background: 'rgba(255, 255, 255, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '32px',
                        fontWeight: 'bold',
                        backdropFilter: 'blur(10px)'
                    }}>
                        M
                    </div>
                    <Text style={{ 
                        fontSize: '14px', 
                        textAlign: 'center',
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontWeight: 500
                    }}>
                        Maveshibids
                    </Text>
                    {/* Favorite Button Skeleton */}
                    <div style={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        zIndex: 2
                    }}>
                        <Skeleton.Button 
                            active 
                            style={{ 
                                width: '32px', 
                                height: '32px', 
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.3)',
                                border: 'none'
                            }} 
                        />
                    </div>
                </div>
                
                {/* Body Content Skeleton */}
                <div style={{ padding: '20px' }}>
                    <Space direction="vertical" size={16} style={{ width: '100%' }}>
                        {/* Category Tag & Title Section */}
                        <div>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'space-between', 
                                marginBottom: 10 
                            }}>
                                <Skeleton.Button 
                                    active 
                                    style={{ 
                                        width: '100px',
                                        height: '24px',
                                        borderRadius: '16px'
                                    }} 
                                />
                                <Skeleton.Button 
                                    active 
                                    style={{ 
                                        width: '70px',
                                        height: '20px',
                                        borderRadius: '16px'
                                    }} 
                                />
                            </div>
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '90%',
                                    height: '22px',
                                    marginBottom: '8px'
                                }} 
                            />
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '70%',
                                    height: '22px'
                                }} 
                            />
                        </div>

                        {/* Info Grid - Lots & Status */}
                        <div style={{ 
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '10px',
                            marginTop: '8px'
                        }}>
                            {/* Lots Count Skeleton */}
                            <div style={{ 
                                background: '#f8fafc',
                                padding: '10px 12px',
                                borderRadius: '10px',
                                border: '1px solid #e2e8f0',
                                overflow: 'hidden'
                            }}>
                                <Space size={6} style={{ width: '100%' }}>
                                    <Skeleton.Avatar active size={16} shape="square" style={{ flexShrink: 0 }} />
                                    <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                        <Skeleton.Input 
                                            active 
                                            style={{ 
                                                width: '40px',
                                                height: '10px',
                                                marginBottom: '6px',
                                                maxWidth: '100%'
                                            }} 
                                        />
                                        <Skeleton.Input 
                                            active 
                                            style={{ 
                                                width: '30px',
                                                height: '18px',
                                                maxWidth: '100%'
                                            }} 
                                        />
                                    </div>
                                </Space>
                            </div>

                            {/* Status/Time Skeleton */}
                            <div style={{ 
                                background: '#f8fafc',
                                padding: '10px 12px',
                                borderRadius: '10px',
                                border: '1px solid #e2e8f0',
                                overflow: 'hidden'
                            }}>
                                <Space size={6} style={{ width: '100%' }}>
                                    <Skeleton.Avatar active size={16} shape="square" style={{ flexShrink: 0 }} />
                                    <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                        <Skeleton.Input 
                                            active 
                                            style={{ 
                                                width: '50px',
                                                height: '10px',
                                                marginBottom: '6px',
                                                maxWidth: '100%'
                                            }} 
                                        />
                                        <Skeleton.Input 
                                            active 
                                            style={{ 
                                                width: '35px',
                                                height: '13px',
                                                maxWidth: '100%'
                                            }} 
                                        />
                                    </div>
                                </Space>
                            </div>
                        </div>

                        {/* Date & Location Row Skeleton */}
                        <div style={{ 
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '8px',
                            padding: '8px 0',
                            borderTop: '1px solid #f3f4f6',
                            borderBottom: '1px solid #f3f4f6'
                        }}>
                            <Space size={6}>
                                <Skeleton.Avatar active size={13} shape="square" />
                                <Skeleton.Input active style={{ width: '100px', height: '11px' }} />
                            </Space>
                            <Space size={6}>
                                <Skeleton.Avatar active size={13} shape="square" />
                                <Skeleton.Input active style={{ width: '80px', height: '11px' }} />
                            </Space>
                        </div>

                        {/* Action Button Skeleton */}
                        <div style={{ marginTop: '4px' }}>
                            <Skeleton.Button 
                                active 
                                style={{ 
                                    width: '100%', 
                                    height: '38px', 
                                    borderRadius: '10px' 
                                }} 
                            />
                        </div>

                        {/* Company Information Skeleton */}
                        <div style={{ 
                            padding: '10px 12px',
                            background: '#f8fafc',
                            borderRadius: '8px',
                            border: '1px solid #e2e8f0',
                            marginTop: '8px'
                        }}>
                            <Space size={10} style={{ width: '100%' }}>
                                <Skeleton.Avatar active size={32} />
                                <div style={{ flex: 1 }}>
                                    <Skeleton.Input active style={{ width: '120px', height: '14px', marginBottom: '4px' }} />
                                    <Skeleton.Input active style={{ width: '80px', height: '12px' }} />
                                </div>
                            </Space>
                        </div>
                    </Space>
                </div>
            </div>
            
            <style jsx>{`
                .skeleton-card {
                    animation: skeleton-loading 1.5s ease-in-out infinite;
                }
                @keyframes skeleton-loading {
                    0% { opacity: 0.6; }
                    50% { opacity: 1; }
                    100% { opacity: 0.6; }
                }
            `}</style>
        </>
    );
};

export default AuctionCardSkeleton; 